
export class SubjectObligedHelper {

  static isDemo(id: number) : boolean {
      return id === 728 // ACME 0 Dev
  }
    
  static isSunGoCar(id: number) : boolean {
      // return id == 430; // DEV
    return id == 450; // PROD
  }

    static isGPAutos(id: number) : boolean {
      return id == 577 || 
             id == 578 || 
             id == 644 ||
             id == 645 ||
             id == 637 ||
             id == 652 ||
             id == 653 ||
             id == 739 ||
             id == 638 || // PROD
             id == 678 || // AUTOCAR SANTA FE SA DE CV
             id == 679;   // AUTOMOBILE SANTA FE SA DE CV
    }
}
